import { render, staticRenderFns } from "./WizardView.vue?vue&type=template&id=2f6aca70&scoped=true&"
import script from "./WizardView.vue?vue&type=script&lang=js&"
export * from "./WizardView.vue?vue&type=script&lang=js&"
import style0 from "./WizardView.vue?vue&type=style&index=0&id=2f6aca70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6aca70",
  null
  
)

export default component.exports